import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Form_Editor, {
    hasUnsavedChanges,
    hasPendingToolboxChanges,
    discardPendingToolboxChanges
} from "./component_unit_form_editor";
import Component_Unit_Form_Settings from "./component_unit_form_settings";
import Unit_Courses from "../unit_courses";
import UnsavedChanges from "../../../shared/unsaved_changes";

const UNSAVED_CHANGES_KEY = "unit-form-editor";

let loading = false;
let tab = "editor";
let unit = null;

// Leaving the editor tab tears down the section/field toolbox, discarding
// whatever was being edited in it, so confirm first.
function switchTab(next) {
    if (tab === next)
        return;

    if (tab === "editor" && hasPendingToolboxChanges()) {
        UnsavedChanges.confirmDiscard(function () {
            discardPendingToolboxChanges();
            tab = next;
            m.redraw();
        });
        return;
    }

    tab = next;
}

const Page_Unit_Form = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        tab = "editor";

        // The toolboxes hold their pending edits in module scope, so anything a
        // previously opened unit left behind would be reported against this one.
        // Clear it before the guard can see it.
        discardPendingToolboxChanges();

        // Registered on the page rather than the editor so the warning still
        // applies while the user is on the settings or courses tab. Toolbox
        // edits are included because they live in the section/field copy and do
        // not reach the unit until saved: the unit-level check alone would let a
        // route change throw them away without asking.
        UnsavedChanges.guard(UNSAVED_CHANGES_KEY, function () {
            return hasUnsavedChanges(unit ? unit.properties : null)
                || hasPendingToolboxChanges();
        });
    },
    onremove: function () {
        UnsavedChanges.release(UNSAVED_CHANGES_KEY);

        // Leaving the page tears the toolbox down, so nothing is pending any
        // more. This also covers confirming the warning above, which unmounts
        // the page once navigation goes through.
        discardPendingToolboxChanges();
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("form_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "editor" ? "active" : "", onclick: function () {
                                    switchTab("editor");
                                }
                            }, i18n.t("editor")),
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () {
                                    switchTab("settings");
                                }
                            }, i18n.t("settings")),
                            m("div", {
                                class: tab === "courses" ? "active" : "", onclick: function () {
                                    switchTab("courses");
                                }
                            }, i18n.t("courses"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "editor" ? m(Component_Unit_Form_Editor, {unit: unit})
                        : tab === "settings" ? m(Component_Unit_Form_Settings, {unit: unit.properties, onCoursesClick: function() { switchTab("courses"); }})
                            : tab === "courses" ? m(Unit_Courses, {unitId: unit.properties.id})
                                : ""
                ] : m(".text-gray padding", i18n.t("invalid_unit"))
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Form;
